export default "__VITE_ASSET__9efb32f6__"